import {convertToSlug} from "../../plugins/convert-to-slug";

export function attachRecommendedStatements($context) {
    if (!$context.length) {
        return true;
    }

    const recommendedStatementsUrl = $context.find('input.object-choose-radio:checked').data('recommended-statement-url');
    const $recommendedStatementsListContainer = $context.find('.recommended-statements-list-container');
    const surveyLanguageId = $context.closest('form').children('input[name="survey_language_id"]').val();
    const questionPartCategoryId = $context.find('input.object-choose-radio:checked').val();
    const slugFromId = convertToSlug($context.prop('id'));
    const recommendedStatementsUrlXhr = 'recommendedStatementsUrlXhr' + slugFromId;
    const recommendedStatementsUrlIsLoading = 'recommendedStatementsUrlIsLoading' + slugFromId;

    // add loading spinner
    $recommendedStatementsListContainer.html(`
        <div class="text-center">
            <div class="spinner-border" role="status"></div>
            <strong class="d-block">Loading data, please wait...</strong>
        </div>
    `);

    window[recommendedStatementsUrlXhr] = $.ajax({
        type: "GET",
        url: recommendedStatementsUrl +
            '/' + questionPartCategoryId +
            '/' + surveyLanguageId,
        beforeSend: function () {
            if (window[recommendedStatementsUrlIsLoading]) {
                window[recommendedStatementsUrlXhr].abort();
            }

            window[recommendedStatementsUrlIsLoading] = true;
        },
        success: function (data) {
            $recommendedStatementsListContainer.html(data);

            // Search statements that begin with the typed phrase and hide others
            $($context).on('keyup', 'input.statements-search', function () {
                let searchNameString = $(this).val().toLowerCase();
                let $statements = $(this).closest('.tab-pane').find('.statements-name');

                $statements.each(function (statementIndex, statementElement) {
                    let showStatement = false;

                    $(statementElement).children('.statement-name').each(function (index, element) {
                        if ($(element).text().toLowerCase().startsWith(searchNameString)) {
                            showStatement = true;

                            return true;
                        }
                    });

                    let statementItem = $(statementElement).closest('.statements-list-item');
                    if (showStatement) {
                        statementItem.show();
                    } else {
                        statementItem.hide();
                    }
                });
            });
        }
    });
}
